import { Dialog } from "primereact/dialog";
import { useState } from "react";
import StatusTag from "../../components/StatusTag";
import { CaseStatus } from "../../constants";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";

/**
 * Modal para remesar caso
 * @param {object} props
 * @param {boolean} props.show
 * @param {() => void} props.onHide
 * @param {import("@tanstack/react-query").UseMutationResult} props.caseMutation
 * @param {number} props.caseId
 */
export default function RemesarCaseDialog({ show, onHide, caseMutation, caseId,  isDemoMode = false }) {
  const [observation, setObservation] = useState("");

  return (
    <Dialog
      id="remesar-case-dialoggg"
      header={isDemoMode ? "Remesar (Modo Demo)" : "Remesar"}
      visible={show}
      style={{ maxWidth: "35rem" }}
      onHide={() => {
        onHide();
        setObservation("");
      }}
      draggable={false}
    >
      <div className="p-fluid text-center">
        <p>
          <b>
            Esto cambiará el estado del caso de{" "}
            <StatusTag value={CaseStatus.ATENDIDO} /> a{" "}
            <StatusTag value={CaseStatus.REMESADO} />
          </b>
        </p>
        {isDemoMode && (
          <p className="text-blue-600 font-bold mt-2">
            🧪 Esta es una simulación. No se realizarán cambios reales.
          </p>
        )}
      </div>
      <div className="p-field flex flex-column">
        <label htmlFor="observation" className="w-fit">
          Observación (opcional)
        </label>
        <InputTextarea
          id="observation"
          value={observation}
          onChange={(e) => setObservation(e.target.value)}
          className="mt-2"
          placeholder="Escriba una observación"
          autoResize
        />
      </div>
      <br></br>
      <div className="delete-confirm-buttons-container">
        <Button
        
          type="button"
          label={isDemoMode ? "Confirmar (Demo)" : "Confirmar"}
          loading={caseMutation.isPending}
          disabled={caseMutation.isPending}
          onClick={() => {
            if (isDemoMode) {
              alert("Modo Demo: Acción simulada. Caso remesado.");
              onHide();
            } else {
              caseMutation.mutate({
                caseId: caseId,
                data: {
                  status: CaseStatus.REMESADO,
                  update_observation: observation,
                },
              });
            }
          }}
        />
        <Button
        id="cancel-remesar-buttongg"
          type="button"
          label="Cancelar"
          style={{ backgroundColor: "#999999", borderColor: "#999999" }}
          disabled={caseMutation.isPending}
          onClick={() => {
            onHide();
            setObservation("");
          }}
        />
      </div>
    </Dialog>
  );
}
